export default __webpack_public_path__ + "media/images/features/local_delivery/morita-san-5634c3b28b7d1aeff4d21f9b8a0f691f.jpg";